import { getApiSessionIdentity } from '../shared/api-client';
import { getPersistentJson } from '../vrs-auth/storage';
import { currentCallHistoryScope } from '../mobile/navigation/callHistoryStorage';
/** Validated account and session identity for standalone Settings; kept in memory only. */
export function currentClientSettingsAccount(allowTenantDiscovery = false) {
    const scope = currentCallHistoryScope(), session = getApiSessionIdentity();
    const user = getPersistentJson('vrs_user_info');
    if (!scope || scope.owner.role !== 'client' || (!scope.owner.tenantId && !allowTenantDiscovery) || !session
        || (user?.role && user.role !== 'client'))
        return null;
    return { id: scope.owner.userId, tenant: scope.owner.tenantId, key: JSON.stringify([scope.key, session]) };
}
